module.exports = __webpack_public_path__ + "static/Country-5ba9a7853079b47fbf97da3fb9df5d83.png";